/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import { forIn } from './lodash';

export const sizeStep = 8;

export function cssSize(n) {
	return n * sizeStep;
}

export function sizeArrayToCss(sizeArray) {
	if (sizeArray == null) {
		return sizeArray;
	}
	const arr = Array.isArray(sizeArray) ? sizeArray : [+sizeArray];

	return arr.length ? `${arr.map(v => v * sizeStep).join('px ')}px` : null;
}

export function mergeStyles(a, b) {
	if (!b) {
		return a;
	}
	const styles = { ...a };
	forIn(b, (value, key) => {
		if (styles[key] == null && value != null) {
			styles[key] = value;
		}
	});

	return styles;
}
